import { React } from "react";
import "./SearchBox.css";
import { SearchIconLeft } from "../../../../IconComponents/index.js";
import { useTranslation } from "react-i18next";
const SearchBox = ({ searchValue, onSearchHandler, placeholder, inputStyle }) => {
  const { t } = useTranslation();
  return (
    <form className="search-form">
      <input
        type="text"
        placeholder={placeholder || t("searchPlaceholder")}
        title={placeholder || t("searchPlaceholder")}
        value={searchValue}
        onChange={(e) => onSearchHandler(e.target.value)}
        style={inputStyle}
      />
      <button disabled={true}>
        <span className="search-icon">
          <SearchIconLeft width="1.3em" height="1.3em" />
        </span>
      </button>
    </form>
  );
};
export default SearchBox;
